/*

  h o m e
  Home

  :description:
  The Home component.

  :TODOS:

  _functionality_
  - Image upload functionality
  - Express concerns about bad language being used and figure out how we want to deal with it
  - logging
  - re-structure desktop landing page

  :branch status:
  DON'T DEPLOY TO MAIN/PROD - It's fine to merge into dev, just waiting on confirmation from PM

*/

//
//  :react & redux:
import React, { useEffect, useState } from 'react'

//
//  :components:
import { Content } from '../components/Content'
import { PAGES } from '../js/statics'

//
//  :packages:
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { useSearchParams } from 'react-router-dom'
import { DesktopLandingPage } from './DesktopLandingPage'
import { isDev } from '../js/utils'
import { useDispatch } from 'react-redux'
import {
  createDiwaliGreeting,
  getDiwaliGreetingAsync,
  patchPublishDiwaliGreetingImageAsync,
  postDiwaliImage,
} from '../features/api/apiSlice'
import { Spinner } from '../components/Spinner'

//
//  :component:
export const Home = props => {
  //
  //  :redux:
  const dispatch = useDispatch()

  //
  //  :active page:
  const [activePage, setActivePage] = useState('landing')

  //
  //  :inputs:
  const [toInput, setToInput] = useState('')
  const [messageInput, setMessageInput] = useState('')
  const [fromInput, setFromInput] = useState('')
  const [imageInput, setImageInput] = useState(null)
  const [fileForUpload, setFileForUpload] = useState(null)

  //
  //  :input validations:
  const [validToInput, setValidToInput] = useState(true)
  const [validMessageInput, setValidMessageInput] = useState(true)
  const [validFromInput, setValidFromInput] = useState(true)
  const [validUniqueCodeInput, SetValidUniqueCodeInput] = useState(true)

  //
  //  :url stuff:
  const [designVersion, setDesignVersion] = useState('12')
  const [searchParams] = useSearchParams(window.location.href)
  const [finalExperienceURL, setFinalExperienceURL] = useState(null)

  //
  //  :unique-code:
  //  :TODO:
  //  Create a greeting and set this value
  // eslint-disable-next-line
  const [uniqueCode, setUniqueCode] = useState('0000')

  //
  //  :other:
  const [showSpinner, setShowSpinner] = useState(false)

  //
  //  ==================================================================================================================
  //
  //  :helpers: (we can probably simplify all of this)
  const isLanding = () => {
    return activePage === PAGES.landing
  }
  const isPersonalise = () => {
    return activePage === PAGES.personalise
  }
  const isCheckYourMessage = () => {
    return activePage === PAGES.checkYourMessage
  }
  const isAddPhoto = () => {
    return activePage === PAGES.addPhoto
  }
  const isCropPhoto = () => {
    return activePage === PAGES.cropPhoto
  }
  const isAllSet = () => {
    return activePage === PAGES.allSet
  }
  const isReceiveGift = () => {
    return activePage === PAGES.receiveGift
  }
  const pageExists = page => {
    return typeof PAGES[page] !== 'undefined'
  }
  const resetValidationInputs = () => {
    setValidToInput(true)
    setValidMessageInput(true)
    setValidFromInput(true)
  }
  const validateInputs = () => {
    resetValidationInputs()

    let inputsAreValid = true
    if (!toInput.length > 0) {
      setValidToInput(false)
      inputsAreValid = false
    }

    if (!messageInput.length > 0) {
      setValidMessageInput(false)
      inputsAreValid = false
    }

    if (!fromInput.length > 0) {
      setValidFromInput(false)
      inputsAreValid = false
    }

    return inputsAreValid
  }

  //
  // ==================================================================================================================
  //
  //  :util:
  const validateUniqueCodeAndNavigateToExperience = async codeInput => {
    if (codeInput.length !== 5) {
      return
    }
    SetValidUniqueCodeInput(true)
    let isValid = true

    setShowSpinner(true)
    const greeting = await dispatch(getDiwaliGreetingAsync(codeInput))
    setShowSpinner(false)

    if (!greeting.payload) {
      isValid = false
    }
    if (greeting.payload?.status >= 200) {
      isValid = true
    }

    let safeUniqueCode = String(codeInput).toUpperCase()
    let safeDesignVersion = String(designVersion)
    let environment = String(isDev() ? 'dev' : 'prod')

    //
    //  make sure we have dev/prod split
    const url = isDev()
      ? 'https://diwali-digital-gifting-dewars-com-staging.bacardistaging.com'
      : 'https://diwali-digital-gifting.dewars.com'

    //
    //  Update location href
    const finalURL = `${url}/experience/index.html?v=${encodeURIComponent(safeDesignVersion)}&c=${encodeURIComponent(
      safeUniqueCode
    )}&e=${encodeURIComponent(environment)}`

    return isValid ? setFinalExperienceURL(finalURL) : SetValidUniqueCodeInput(false)
  }
  const navigateToPage = (page, eventLog) => {
    if (page === PAGES.checkYourMessage) {
      if (!validateInputs()) {
        return
      }
    }
    if (pageExists(page)) {
      // window.location.hash = `#${page}`
      triggerEvent(eventLog)
      setActivePage(page)
    }
  }
  const navigateToExperience = (passedUniqueCode = '0000', eventLog) => {
    //
    // Ensure passedUniqueCode & designVersion is a string
    let safeUniqueCode = String(passedUniqueCode).toUpperCase()
    let safeDesignVersion = String(designVersion)
    let environment = String(isDev() ? 'dev' : 'prod')

    //
    //  make sure we have dev/prod split
    const url = isDev()
      ? 'https://diwali-digital-gifting-dewars-com-staging.bacardistaging.com'
      : 'https://diwali-digital-gifting.dewars.com'

    //
    //  Update location href
    const finalURL = `${url}/experience/index.html?v=${encodeURIComponent(safeDesignVersion)}&c=${encodeURIComponent(
      safeUniqueCode
    )}&e=${encodeURIComponent(environment)}`

    setFinalExperienceURL(finalURL)
    triggerEvent(eventLog)

    const linkEl = document.createElement('a')
    linkEl.href = finalURL
    linkEl.rel = 'noreferrer'

    if (window.open) {
      window.open(finalURL, '_blank')
    } else {
      linkEl.target = '_blank'
      linkEl.click()
    }
  }
  const createGreetingAndNavigateToPage = async (page, formData, eventLog) => {
    setShowSpinner(true)

    let imagePath = null
    let IMAGE_ID = null

    //
    //  :step 0:
    //  Upload the image to the temp folder
    if (formData) {
      const payload = {
        file: formData,
      }
      imagePath = await dispatch(postDiwaliImage(payload))
      IMAGE_ID = imagePath.payload.id
    }

    const uri = isDev()
      ? 'https://diwali-digital-gifting-dewars-com-staging.bacardistaging.com'
      : 'https://diwali-digital-gifting.dewars.com'

    //
    //  :step 1:
    //  Form our payload
    //  design, to, from, message, image
    const payload = {
      id: IMAGE_ID,
      design: designVersion,
      to: toInput,
      from: fromInput,
      message: messageInput,
      image: IMAGE_ID ? `${uri}/v1/greetings/${IMAGE_ID}.jpg` : 'null',
    }

    //
    //  :step 2:
    //  Dispatch the create greeting event
    const returnedGreeting = await dispatch(createDiwaliGreeting(payload))
    const greetingID = returnedGreeting.payload

    //
    //  Wait for a short while.
    //await new Promise(r => setTimeout(r, 2000))

    //
    //  :step 3:
    //  Dispatch the image publishing.
    // eslint-disable-next-line
    const imagePublishingResponse = await dispatch(
      patchPublishDiwaliGreetingImageAsync({
        id: greetingID,
        extension: fileForUpload ? fileForUpload.name.split('.').pop() : null,
      })
    )

    //
    //  :step 3:
    //  updates
    setShowSpinner(false)
    setUniqueCode(returnedGreeting.payload)

    //
    //  :step 4:
    //  Navigate
    navigateToPage(page, eventLog)
  }

  const triggerEvent = event => {
    //
    //  GTM
    if (isDev()){
      return
    }
    if (window.registerButtonClick && event) {
      window.registerButtonClick(event)
    }
  }

  //
  // ==================================================================================================================
  //
  //  :useEffects
  useEffect(() => {
    //
    // Set the design version based on query parameters, or use '12' as the default
    const defaultVersion = '12'
    const version = searchParams.has('v') ? searchParams.get('v') : defaultVersion

    setDesignVersion(version)
  }, [searchParams])

  //
  // ==================================================================================================================
  //
  //  :event-handlers:
  const handleImageUpload = event => {
    const file = event.target.files[0]
    if (file) {
      setFileForUpload(file)
      const reader = new FileReader()
      reader.onload = function (e) {
        setImageInput(e.target.result)
        navigateToPage('cropPhoto', 'btn_upload')
      }
      reader.readAsDataURL(file)
    }
  }
  const emailUniqueCodeEvent = () => {
    const params = new URLSearchParams(window.location.search)

    if (window.SPOTLIGHT) {
      window.SPOTLIGHT.openPromotion('dewarsGTRdiwali23GLB', {
        sourceTag: params.get('sourcetag') ? params.get('sourcetag') : '',
        survey: {
          code: uniqueCode,
        },
      })
    }

    triggerEvent('btn_email')
  }

  //
  //  ==================================================================================================================
  //
  //  :render functions:
  const landing = () => {
    return (
      <div className="eky-diwali-landing flex flex-col items-center relative w-full h-screen relative uppercase">
        <img
          className="absolute bottom-0 w-full "
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />
        <img
          className="absolute top-0 left-0 max-w-[22rem]"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-title-002.svg"
          alt=""
        />

        <div className="landing-buttons flex flex-col text-white align-bottom h-full justify-end z-[2] w-full">
          <div className="p-4 flex flex-col">
            <button
              className="eky-diwali-button-large landing-button text-xl flex flex-col justify-center items-center"
              onClick={() => navigateToPage('receiveGift', 'btn_recieve')}
            >
              <p className="eky-button-text-main">Got a unique gift code?</p>
              <p className="eky-button-text-sub">tap here to Experience your gift</p>
            </button>
            <button
              className={`eky-diwali-button-large landing-button my-2`}
              onClick={() => {
                navigateToPage('personalise', 'btn_personalise')
              }}
            >
              <p className="eky-button-text-main">giving a gift?</p>
              <p className="eky-button-text-sub">tap here to personalise your message</p>
            </button>
            <button className="eky-diwali-button-large landing-button" onClick={() => navigateToExperience('0000', 'btn_not-gifting')}>
              <p className="eky-button-text-main">not got a unique code?</p>
              <p className="eky-button-text-sub">tap here to experience anyway</p>
            </button>
          </div>
        </div>
        <div className="text-[15px] mt-2 cursor-pointer z-[3] text-white underline uppercase mb-[7.5rem]">
          <a
            className="underline z-[2]"
            href="https://www.dewars.com/terms-and-conditions/"
            rel="noreferrer"
            target="_blank"
            onClick={() => {triggerEvent('btn_terms')}}
          >
            terms & conditions
          </a>
        </div>
      </div>
    )
  }

  const personalise = () => {
    return (
      <div className="eky-diwali-personalise flex flex-col items-center w-full h-full relative uppercase">
        <img
          className="absolute bottom-0 opacity-[20%] w-full"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />

        <div className="text-[36px] text-white uppercase text-center px-[4rem] py-2 leading-[36px] z-[2]">
          Personalise your message
        </div>
        <div className="flex flex-col form-inputs w-full p-4 z-[2]">
          <div className="eky-diwali-input-box">
            <p className={`${validToInput ? 'text-black text-[23px]' : 'text-red-600 text-[23px]'}`}>
              Who is this gift for?
            </p>
            <input
              type="text"
              name="to"
              id="input-to"
              placeholder="PLEASE ENTER THE RECIPIENT'S NAME*"
              maxLength={30}
              onChange={e => {
                setToInput(e.target.value)
              }}
              value={toInput}
            />
            <div className="divider mt-1"></div>
          </div>
          <div className="eky-diwali-input-box my-3">
            <p className={`${validMessageInput ? 'text-black text-[23px]' : 'text-red-600 text-[23px]'}`}>
              Write your message
            </p>
            <div className="flex flex-col w-full">
              <textarea
                className="mt-2"
                type="text"
                name="message"
                id="input-message"
                placeholder="PLEASE ENTER YOUR PERSONALISED MESSAGE*"
                maxLength="50"
                style={{ height: '28px' }}
                onChange={e => {
                  setMessageInput(e.target.value)
                }}
                value={messageInput}
              />
              <div className="divider"></div>
              <p className="uppsercase text-[10px] mt-2">maximum 50 characters</p>
            </div>
          </div>
          <div className="eky-diwali-input-box z-[2]">
            <p className={`${validFromInput ? 'text-black text-[23px]' : 'text-red-600 text-[23px]'}`}>
              Who is the gift from?
            </p>
            <input
              type="text"
              name="from"
              id="input-from"
              placeholder="PLEASE ENTER YOUR NAME*"
              onChange={e => {
                setFromInput(e.target.value)
              }}
              value={fromInput}
            />
            <div className="divider mt-1"></div>
          </div>
        </div>
        <div className="nav-buttons w-full h-full mt-2 z-[2]">
          <div className="flex flex-col items-center h-full w-full">
            <button
              className="eky-diwali-button-small landing-button"
              onClick={() => navigateToPage('checkYourMessage', 'btn_per-continue')}
            >
              <p className="eky-button-text-main">Continue</p>
            </button>
            <button className="eky-diwali-button-small landing-button my-2" onClick={() => navigateToPage('landing', 'btn_back')}>
              <p className="eky-button-text-main">Go back</p>
            </button>
          </div>
        </div>
      </div>
    )
  }

  const checkYourMessage = () => {
    return (
      <div className="eky-check-your-message flex flex-col items-center w-full h-screen relative p-4 uppercase">
        <img
          className="absolute bottom-0 opacity-[20%] w-full"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />

        <div className="text-[36px] text-white uppercase text-center px-[2rem] leading-[36px] z-[2]">
          Check your message
        </div>
        <div className="flex w-full p-3 justify-center">
          <div className="eky-check-your-message-box my-2 z-[2] max-w-[390px] max-h-[350px]">
            <div>
              <p>{toInput},</p>
            </div>
            <div>
              <p>{messageInput}</p>
            </div>
            <div className="flex flex-col">
              <p style={{ lineHeight: 'initial' }}>from, </p>
              {fromInput}
            </div>
          </div>
        </div>
        <div className="nav-buttons w-full mt-2 z-[2]">
          <div className="flex flex-col items-center h-full w-full">
            <button className="eky-diwali-button-small landing-button" onClick={() => navigateToPage('addPhoto', 'btn_looks-good')}>
              <p className="eky-button-text-main">looks good</p>
            </button>
            <button
              className="eky-diwali-button-small landing-button my-2"
              onClick={() => navigateToPage('personalise', 'btn_change')}
            >
              <p className="eky-button-text-main">change message</p>
            </button>
          </div>
        </div>
      </div>
    )
  }

  const addPhoto = () => {
    return (
      <div className="eky-diwali-add-photo flex flex-col items-center w-full h-screen relative p-4 uppercase">
        <img
          className="absolute bottom-0 opacity-[20%] w-full"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />

        <div className="text-[36px] text-white uppercase text-center px-[1rem] pt-2 leading-[36px] z-[2]">
          do you want to add a photo?
        </div>

        <div className="flex w-full justify-center">
          <div className="eky-diwali-image-upload-container z-[2] my-6">
            <label htmlFor="file-input">
              <img
                src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-add-photo-icon-001.svg"
                alt="upload-icon"
              />
            </label>

            <input
              id="file-input"
              type="file"
              className="eky-diwali-file-input hidden"
              onChange={handleImageUpload}
              accept="image/*"
            />
          </div>
        </div>

        <div className="nav-buttons w-full z-[2]">
          <div className="flex flex-col items-center w-full h-full">
            <label className="eky-diwali-button-small" htmlFor="file-input-002">
              <p className="eky-button-text-main">upload photo</p>
            </label>

            <input
              id="file-input-002"
              type="file"
              className="eky-diwali-file-input hidden"
              onChange={handleImageUpload}
              accept="image/*"
            />

            <button className="eky-diwali-button-small my-2" onClick={() => createGreetingAndNavigateToPage('allSet', null, 'btn_skip')}>
              <p className={`eky-button-text-main`}>Skip</p>
            </button>
          </div>
        </div>
      </div>
    )
  }

  const cropPhoto = () => {
    if (!imageInput) {
      return
    }
    // eslint-disable-next-line
    let cropper = null

    const initializeCropper = async () => {
      if (imageInput) {
        setTimeout(() => {
          let canvasEl = document.getElementById('canvas')
          if (!canvasEl) {
            return
          }
          const ctx = canvasEl.getContext('2d')
          const img = new Image()
          img.src = imageInput
          img.onload = () => {
            canvasEl.width = img.width
            canvasEl.height = img.height
            ctx.drawImage(img, 0, 0, img.width, img.height)

            //
            //  Create a new 'CropperJS' instance
            const cropperOptions = {
              modal: true,
              guides: false,
              center: false,
              highlight: false,
              background: false,
              autoCrop: true,
              autoCropArea: 1,
              cropBoxMovable: true,
              cropBoxResizable: false,
              viewMode: 3,
              ready() {
                this.cropper.crop()
              },
            }

            cropper = new Cropper(canvasEl, cropperOptions)
          }
        }, 1000)
      }
    }

    const exportCroppedImage = () => {
      if (!imageInput) {
        return
      }

      //
      //  :todo:
      cropper.getCroppedCanvas().toBlob(blob => {
        var file = new File([blob], fileForUpload.name)
        createGreetingAndNavigateToPage('allSet', file, 'btn_looks-good')
      })
    }

    const processCroppedCanvasAndContinue = async () => {
      exportCroppedImage()
    }

    initializeCropper()

    return (
      <div className="eky-diwali-crop-photo flex flex-col items-center w-full h-screen relative p-4 uppercase">
        <img
          className="absolute bottom-0 opacity-[20%] w-full"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />

        <div className="text-[36px] text-white uppercase text-center px-[1rem] pt-2 leading-[36px] z-[2]">
          Pinch to crop and centre your photo
        </div>

        <div className="flex w-full justify-center">
          <div className="image-upload eky-diwali-image-upload-container-crop z-[2] my-6 z-[2]">
            <canvas className="max-w-full rounded-full w-full h-full" id="canvas"></canvas>
          </div>
        </div>

        <div className="nav-buttons w-full z-[2]">
          <div className="flex flex-col items-center">
            <button className="eky-diwali-button-small" onClick={() => processCroppedCanvasAndContinue()}>
              <p className="eky-button-text-main">Looks good</p>
            </button>
            <button className="eky-diwali-button-small my-2" onClick={() => navigateToPage('addPhoto', 'btn_change')}>
              <p className="eky-button-text-main">Change photo</p>
            </button>
          </div>
        </div>
      </div>
    )
  }

  const allSet = () => {
    const onClickCopyToClickBoard = () => {
      if (navigator && uniqueCode) {
        navigator.clipboard.writeText(uniqueCode)
      }
    }

    return (
      <div className="eky-diwali-all-set flex flex-col items-center w-full h-screen relative p-4 uppercase">
        <img
          className="absolute bottom-0 opacity-[20%] w-full"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />

        <div className="text-[36px] text-white uppercase text-center py-2 leading-[36px] z-[2]">You're all set!</div>

        <div
          className="unique-code w-full h-auto bg-white opacity-[60%] rounded-lg flex flex-col justify-center items-center my-4 z-[2] pt-[3rem] px-4"
          onClick={() => {
            onClickCopyToClickBoard()
          }}
        >
          <p className="text-[80px] text-black font-medium" id="copy-unique-code">
            {uniqueCode}
          </p>
          <p className="mt-1 max-w-[11rem] text-[15px] text-center">remember to write this unique code on the pack</p>
        </div>

        <div className="flex flex-col text-center justify-between z-[2] leading-none ">
          <p className="text-[23px] text-white text-center">All done!</p>
          <p className="text-[23px] text-white text-center">Tap below to preview your gift.</p>
        </div>

        <div className="nav-buttons w-full h-full flex justify-center mt-4 z-[2]">
          <div className="flex flex-col items-center">
            <button className="eky-diwali-button-small" onClick={() => emailUniqueCodeEvent()}>
              <p className="eky-button-text-main">Email me my code</p>
            </button>
            <button className="eky-diwali-button-small my-2" onClick={() => navigateToExperience(uniqueCode, 'btn_preview')}>
              <p className="eky-button-text-main">Preview experience</p>
            </button>
            <button className="eky-diwali-button-small" onClick={() => navigateToPage('landing', 'btn_home')}>
              <p className="eky-button-text-main">Home</p>
            </button>
          </div>
        </div>
      </div>
    )
  }

  const receiveGift = () => {
    return (
      <div className={`eky-diwali-recieve-gift flex flex-col items-center w-full h-screen relative p-4 uppercase`}>
        <img
          className="absolute bottom-0 opacity-[20%] w-full"
          src="https://cdn.pointandplace.com/services/dewars-diwali-app/assets/dewars-diwali-mandala-001.png"
          alt=""
        />
        <div className="text-[36px] text-white uppercase text-center px-[0.5rem] py-2 leading-[36px] z-[2]">
          Enter the unique code written on your gift
        </div>

        <div
          className={`unique-code my-4 z-[2] flex flex-col w-full max-w-[25rem] bg-white opacity-[60%] rounded-lg min-h-[14rem] p-4 ${
            validUniqueCodeInput ? 'eky-diwali-valid-unique-code' : 'eky-diwali-invalid-unique-code'
          }`}
        >
          <p className="text-[23px]">Enter your code</p>
          <div className="flex flex-col w-full h-full text-center justify-center items-center">
            <input
              className="text-center w-[70%] text-[80px] leading-none border-b-2 border-black eky-diwali-unique-code-input"
              type="text"
              name=""
              id=""
              maxLength={5}
              placeholder="please enter your five digit code*"
              onChange={e => validateUniqueCodeAndNavigateToExperience(e.target.value)}
            />
          </div>
        </div>

        <div className="nav-buttons w-full mt-4 z-[2] h-full flex justify-center mb-[5rem]">
          <div className="flex flex-col items-center">
            <a className="eky-diwali-button-small z-[2]" href={finalExperienceURL} onClick={(e) => {triggerEvent('btn_rec-continue')}} rel="noreferrer" target="_blank">
              <p className="eky-button-text-main">Continue</p>
            </a>
            {/* <button
              className="eky-diwali-button-small"
              onClick={() => {
                validateUniqueCodeAndNavigateToExperience()
              }}
            >
              <p className="eky-button-text-main">Continue</p>
            </button> */}
            <button className="eky-diwali-button-small my-2" onClick={() => navigateToPage('landing', 'btn_dont-have')}>
              <p className="eky-button-text-main"> Don't have a pin?</p>
            </button>
          </div>
        </div>
      </div>
    )
  }

  //
  //  ==================================================================================================================
  //
  //  :main render:
  return (
    <>
      <Content>
        <div className="hidden md:flex">
          <DesktopLandingPage></DesktopLandingPage>
        </div>
        <div className="flex flex-col relative w-full h-screen md:hidden">
          {showSpinner && <Spinner></Spinner>}
          {isLanding() && landing()}
          {isPersonalise() && personalise()}
          {isCheckYourMessage() && checkYourMessage()}
          {isAddPhoto() && addPhoto()}
          {isCropPhoto() && cropPhoto()}
          {isAllSet() && allSet()}
          {isReceiveGift() && receiveGift()}
          <img src="" id="cropped-image" alt="" className={`${isCropPhoto() === false ? 'hidden' : ''}`} />
        </div>
      </Content>
    </>
  )
}
